export default "__VITE_ASSET__tPk6dI70__"